import usePrivateAxios from "@/common/api/usePrivateAxios";
import { ErrorResponse } from "@/common/types/errorResponse";
import { useMutation } from "@tanstack/react-query";

interface UseCardMarkAsApprovedProps {
  cardId?: string;
  onSuccess?: () => void;
  onError?: (error: ErrorResponse) => void;
}

export const useCardMarkAsApproved = ({ cardId, onSuccess, onError }: UseCardMarkAsApprovedProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['clientCardsMarkAsApproved'],
    mutationFn: () => privateAxios.post(`/client/cards/${cardId}/mark_as_approved/`),
    onSuccess,
    onError,
  });
};
